import { HTTP_INTERCEPTORS, provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { ApplicationConfig, isDevMode } from '@angular/core';
import { provideServiceWorker } from '@angular/service-worker';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, withEnabledBlockingInitialNavigation, withInMemoryScrolling } from '@angular/router';
import Aura from '@primeuix/themes/aura';
import { providePrimeNG } from 'primeng/config';
import { appRoutes } from './app.routes';
import { TokenInterceptor } from '@/interceptors/token.interceptor';
import { AuthGuard } from '@/middleware/auth.guard';

export const appConfig: ApplicationConfig = {
    providers: [
        AuthGuard,
        provideHttpClient(withInterceptorsFromDi(), withFetch()),
        {
            provide: HTTP_INTERCEPTORS,
            useClass: TokenInterceptor,
            multi: true
        },
        provideRouter(
            appRoutes,
            withInMemoryScrolling({ anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled' }),
            withEnabledBlockingInitialNavigation()
        ),
        provideHttpClient(withFetch()),
        provideAnimationsAsync(),
        providePrimeNG({ theme: { preset: Aura, options: { darkModeSelector: '.app-dark' } } }),
        provideServiceWorker('ngsw-worker.js', {
            // Forzamos enabled a true para poder probar la PWA localmente con "npm run start:pwa"
            // (Si usas "npm run start" normal, lanzará un 404 inofensivo buscando ngsw-worker.js)
            enabled: true,
            registrationStrategy: 'registerImmediately'
        })
    ]
};
